import React from 'react';
import BrandSection from './components/BrandSection/BrandSection';
import MediaList from './components/MediaList/MediaList';
import LinkList from './components/LinkList/LinkList';
import styles from './Footer.module.css';
import { getImageProps } from 'next/image';
import { getBackgroundImage } from 'frontend/utils/helpers';
const Footer = () => {
  const {
    props: {
      srcSet
    }
  } = getImageProps({
    alt: '',
    width: '1162',
    height: '409',
    src: '/images/pattern-raspberry-footer.svg'
  });
  const backgroundImage = getBackgroundImage(srcSet);
  return <div className={styles.footerWrapper} style={{
    backgroundImage
  }} data-sentry-component="Footer" data-sentry-source-file="Footer.tsx">
      <div className={styles.borderBottom}>
        <div className={styles.topContentWrapper}>
          <div className={styles.footerContentMedia}>
            <MediaList data-sentry-element="MediaList" data-sentry-source-file="Footer.tsx" />
          </div>
          <div className={styles.footerContentLink}>
            <LinkList data-sentry-element="LinkList" data-sentry-source-file="Footer.tsx" />
          </div>
        </div>
      </div>
      <div className={styles.footerContentBrand}>
        <BrandSection data-sentry-element="BrandSection" data-sentry-source-file="Footer.tsx" />
      </div>
    </div>;
};
export default Footer;